import { IconName } from '@/types/icons';

// SVG path data for each icon (24x24 viewBox)
export const iconPaths: Record<IconName, string[]> = {
  'dice-d20': [
    'M12 2l9 4.5v11L12 22l-9-4.5v-11L12 2zm0 2.311L5.5 7.653v8.694L12 19.689l6.5-3.342V7.653L12 4.311zM12 7l4.33 2.5v5L12 17l-4.33-2.5v-5L12 7z'
  ],
  'dice-d6': [
    'M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm2 4a1 1 0 100 2 1 1 0 000-2zm10 0a1 1 0 100 2 1 1 0 000-2zm-5 4a1 1 0 100 2 1 1 0 000-2zm-5 4a1 1 0 100 2 1 1 0 000-2zm10 0a1 1 0 100 2 1 1 0 000-2z'
  ],
  'dice-d10': [
    'M12 2l7.7 5.6v8.8L12 22l-7.7-5.6V7.6L12 2zm0 2.5L6.5 8.4v7.2l5.5 4 5.5-4V8.4L12 4.5z'
  ],
  'dice-d4': [
    'M12 2L2 20h20L12 2zm0 4.5L16.5 17h-9L12 6.5z'
  ],
  'dice-d8': [
    'M12 2l8.5 5v10L12 22l-8.5-5V7L12 2zm0 2.7L5.5 8.3v7.4l6.5 3.6 6.5-3.6V8.3L12 4.7z'
  ],
  'dice-d12': [
    'M12 2l7.07 2.93a1 1 0 01.52.52L22.52 12l-2.93 7.07a1 1 0 01-.52.52L12 22.52l-7.07-2.93a1 1 0 01-.52-.52L1.48 12l2.93-7.07a1 1 0 01.52-.52L12 2z'
  ],
  'sword': [
    'M6.92 5H5l9 9 1.92-1.92L11 7.16V3h-1v4.16L6.92 5zM3.21 10.83l1.92 1.92L10 17.61V21h1v-3.61l4.87-4.86 1.92-1.92L13 5.83v1.34l4.29 4.29-1.41 1.41L11 8v9.17l-7.79-6.34z'
  ],
  'shield': [
    'M12 2L4 7v5c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V7l-8-5zm0 2.18l6 3.71v4.11c0 4.52-2.98 8.69-6 9.83-3.02-1.14-6-5.31-6-9.83V7.89l6-3.71z'
  ],
  'heart': [
    'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
  ],
  'crosshair': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z'
  ],
  'chevron-up': [
    'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z'
  ],
  'chevron-down': [
    'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z'
  ],
  'chevron-left': [
    'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z'
  ],
  'chevron-right': [
    'M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z'
  ],
  'close': [
    'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
  ],
  'menu': [
    'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'
  ],
  'settings': [
    'M12 8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
    'M13.61 8.13l-.61-.6-.61.6a2.5 2.5 0 01-3.54 0 2.5 2.5 0 010-3.54L12 2l3.15 2.59a2.5 2.5 0 010 3.54 2.5 2.5 0 01-3.54 0z'
  ],
  'save': [
    'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z'
  ],
  'load': [
    'M9 3v6h1.5L7.5 13.5 4.5 9H6V3M16.5 9L19.5 13.5 16.5 18H15v6H9v-6h1.5l-3-4.5 3-4.5H12V3h6v6z'
  ],
  'search': [
    'M15.5 14h-.79l-.28-.27a6.5 6.5 0 10-.7.7l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'
  ],
  'filter': [
    'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z'
  ],
  'sort': [
    'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z'
  ],
  'add': [
    'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'
  ],
  'remove': [
    'M19 13H5v-2h14v2z'
  ],
  'edit': [
    'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
  ],
  'copy': [
    'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z'
  ],
  'paste': [
    'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z'
  ],
  'undo': [
    'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z'
  ],
  'redo': [
    'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z'
  ],
  'print': [
    'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z'
  ],
  'download': [
    'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z'
  ],
  'upload': [
    'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5v-2z'
  ],
  'share': [
    'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z'
  ],
  'favorite': [
    'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
  ],
  'star': [
    'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'
  ],
  'info': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'
  ],
  'warning': [
    'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z'
  ],
  'error': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
  ],
  'success': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
  ],
  'help': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z'
  ],
  'theme-light': [
    'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM13 3v2h-2V3h2zm5.66 4.66l-1.41 1.41-1.41-1.41 1.41-1.41 1.41 1.41zM21 11v2h-2v-2h2zM5 11v2H3v-2h2zm2.05-4.95l1.41 1.41L6.05 5.05 4.63 6.46l1.41 1.41zM15.24 18.16l1.41 1.41-1.41 1.41-1.41-1.41 1.41-1.41zM8.76 18.16l1.41 1.41-1.41 1.41-1.41-1.41 1.41-1.41zM13 21v-2h-2v2h2z'
  ],
  'theme-dark': [
    'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z'
  ],
  'theme-auto': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18V4c4.41 0 8 3.59 8 8s-3.59 8-8 8z'
  ],
  'accessibility': [
    'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z'
  ],
  'font-size': [
    'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z'
  ],
  'contrast': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18V4c4.41 0 8 3.59 8 8s-3.59 8-8 8z'
  ],
  'motion': [
    'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.91 19.67l-1.96-6.36-1.52 2.04v3.32H5v-4.93l2.19-2.89c.62-.83 1.39-1.29 2.26-1.35.23 0 .47.02.71.08.78.2 1.4.8 1.61 1.62l.73 2.38c.31 1.01 1.23 1.7 2.29 1.7h1.71v1.5h-1.71c-1.71 0-3.19-1.16-3.61-2.82l-.5-1.57-1.11 1.48L11.41 16l.72 2.34c.28.89-.12 1.84-.91 2.3-.24.14-.5.21-.75.21-.61 0-1.21-.31-1.56-.84z'
  ],
  'keyboard': [
    'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z'
  ],
  'cyberware': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4V6z'
  ],
  'netrunner': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v2h4v-2h-4zM12 11h2c1.1 0 2 .9 2 2v.5c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1V13c0-1.1.9-2 2-2zm0-6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z'
  ],
  'gun': [
    'M7 5h10v2h1l1 1v1l-1 1v1h-1v2H6V7h1V5zm12 3v3h2v1h-4V8h2zm-4 7h-5v3h-1v-3H4v-1h11v1z'
  ],
  'armor': [
    'M12 1L3 5v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V5l-8-4zm6 10c0 4.52-2.98 8.69-6 9.93-3.02-1.23-6-5.41-6-9.93V6.3l6-3.01 6 3.01V11z'
  ],
  'vehicle': [
    'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z'
  ],
  'money': [
    'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z'
  ],
  'chip': [
    'M17 7h-4V3h-2v4H7c-1.1 0-2 .9-2 2v2H1v2h4v4h2v4h2v-4h4v4h2v-4h2v-4h4v-2h-4V9c0-1.1-.9-2-2-2zM7 13v-4h10v4H7z'
  ],
  'biohazard': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.93c1.77.34 3.28 1.47 4.12 3.07h-2.62c-.35-.76-.97-1.37-1.74-1.7l.24-1.37zM12 7c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zM6.88 9h2.62c.35.76.97 1.37 1.74 1.7l-.24 1.37C9.23 11.73 7.72 10.6 6.88 9zM11 18.07c-1.77-.34-3.28-1.47-4.12-3.07h2.62c.35.76.97 1.37 1.74 1.7l-.24 1.37zm2 0l-.24-1.37c.77-.33 1.39-.94 1.74-1.7h2.62c-.84 1.6-2.35 2.73-4.12 3.07z'
  ],
  'radiation': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.46 14.45L5.67 17c-.69-.88-1.14-1.95-1.29-3.11l3.77-.58c.19.77.64 1.46 1.31 2.14zm7.08 0c.67-.68 1.12-1.37 1.31-2.14l3.77.58c-.15 1.16-.6 2.23-1.29 3.11l-2.79-2.55zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm6.33-10c.69.88 1.14 1.95 1.29 3.11l-3.77.58c-.19-.77-.64-1.46-1.31-2.14L18.33 7zm-12.66 0l2.79 2.55c-.67.68-1.12 1.37-1.31 2.14l-3.77-.58c.15-1.16.6-2.23 1.29-3.11z'
  ],
  'electric': [
    'M11 21h-1l1-7H7l4-9v6h4l-4 10z'
  ],
  'fire': [
    'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z'
  ],
  'ice': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14l-4 7h3v3h2v-3h3l-4-7z'
  ],
  'poison': [
    'M14.5 3.5c0-1.38-1.12-2.5-2.5-2.5S9.5 2.12 9.5 3.5c0 1.28.96 2.32 2.2 2.48V14h-2v2h4.5v-2h-2V6c1.24-.17 2.2-1.21 2.2-2.5zM12 2.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM16 18c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2v-1h9v1zm1-3H6c-.55 0-1 .45-1 1v3c0 2.21 1.79 4 4 4h5c2.21 0 4-1.79 4-4v-3c0-.55-.45-1-1-1z'
  ],
  'drug': [
    'M6 3v7c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3h-2v4h-2V3h-2v4h-2V3H8v4H6V3H6zm10 8H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm-8 3v7c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2zm2 0h4v7h-4v-7z'
  ],
  'medical': [
    'M19 3h-6V1h-2v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4v4z'
  ],
  'tech': [
    'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z'
  ],
  'corpo': [
    'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-4v2h4v-2zm0 4h-4v2h4v-2z'
  ],
  'nomad': [
    'M12 2L4.5 20.5l.71.71L12 18l6.79 3.21.71-.71L12 2z'
  ],
  'streetkid': [
    'M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h3.54c.64 0 1.15-.52 1.15-1.15 0-.64-.51-1.15-1.15-1.15h-.85L14.83 8l1.77-1.75c.64-.64 1.5-1 2.4-1 .85 0 1.7.33 2.36 1l2.14-2.12C22.31 2.95 20.52 2.18 18.6 2.18c-2.13 0-4.12.85-5.6 2.36L7.39 10.15c-.47.47-.72 1.08-.72 1.72 0 .36.08.71.24 1.03l-3.09 3.09 1.41 1.41 2.09-2.09h-.01c.31.16.67.24 1.03.24h6.65c1.89 0 3.42-1.53 3.42-3.42s-1.53-3.51-3.42-3.51h-1.48l1.84-1.84c.71-.71 1.65-1.06 2.58-1.06.82 0 1.64.28 2.28.84l2.14-2.13c-1.13-1.16-2.7-1.81-4.42-1.81z'
  ],
  'rockerboy': [
    'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z'
  ],
  'solo': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM12 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm4 8.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
  ],
  'fixer': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm6.99-5.36c-.67.66-1.75.66-2.42 0-.67-.67-.67-1.76 0-2.42.67-.67 1.75-.67 2.42 0 .67.66.67 1.75 0 2.42z'
  ],
  'cop': [
    'M12 1L3 5v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z'
  ],
  'medtech': [
    'M12 2L2 7v10c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V7l-10-5zm6 13h-5v5h-2v-5H6v-2h5V8h2v5h5v2z'
  ],
  'media': [
    'M3 3v18h18v-2H5V3H3zm14 4H7v10h10V7zm-2 8h-2v-2h-2v2H9v-2h2v-2h2v2h2v2z'
  ],
  'night-city': [
    'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z'
  ],
  'map': [
    'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z'
  ],
  'location': [
    'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
  ],
  'npc': [
    'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z'
  ],
  'player': [
    'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'
  ],
  'encounter': [
    'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z'
  ],
  'combat': [
    'M7 5h10v2h2v1l-1 6v1h-1v2H6v-2H5v-1l-1-6V7h2V5zm10 1H7v1h10V6zm-8 4h6v1h-6v-1zm6 2H9v1h6v-1z'
  ],
  'stealth': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6 0 1.66.67 3.16 1.76 4.24l8.48-8.48C15.16 6.67 13.66 6 12 6z'
  ],
  'hacking': [
    'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H9v-2h6v2zm3-4H6V8h12v6z'
  ],
  'social': [
    'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
  ],
  'reflex': [
    'M10.59 4.59C12.1 3.08 14.24 2.1 16.5 2.1c4.42 0 8 3.58 8 8s-3.58 8-8 8c-2.73 0-5.14-1.37-6.59-3.46l.23-.34c.84-1.18 1.37-2.49 1.5-3.86l1.3-1.3c.2.47.56.86 1.03 1.12l.03.01c1.23.61 2.73.24 3.53-.86l.01-.01c.31-.43.47-.95.47-1.47 0-.74-.32-1.47-.94-2.08-.63-.63-1.53-.94-2.4-.85-.41.04-.81.17-1.16.38-.25.16-.48.35-.68.57l-.01.01c-.9.92-1.2 2.27-.72 3.48l-1.34 1.34c-.2-.1-.41-.19-.63-.26-.09-.03-.18-.05-.27-.07-.1-.02-.21-.04-.32-.05-.1-.01-.2-.01-.31-.01-.09 0-.19.01-.28.02-.09.01-.18.03-.27.05l-2.85-2.85zM5.59 15.41c-.78-.78-.78-2.05 0-2.83l4.24-4.24c.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83l-4.24 4.24c-.78.78-2.05.78-2.83 0z'
  ],
  'endurance': [
    'M14.5 2.5c0 1.5-1.5 6-1.5 6h-2s-1.5-4.5-1.5-6c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5zM18 8h-5.5l-.66 5.29c-.04.28-.34.48-.62.4l-3.05-.9c-.19-.05-.37.02-.48.17l-1.87 2.75c-.28.42-.16.98.26 1.26.42.28.98.16 1.26-.26l1.5-2.2 2.19.64 1.44 2.78c.18.35.54.57.93.57h1.5c.45 0 .84-.26 1.03-.65l2.87-5.82c.21-.43.02-.94-.41-1.15-.43-.21-.94-.02-1.15.41l-2.44 4.96-1.22-2.35L18 8z'
  ],
  'intelligence': [
    'M9 15l7.17 3.17.83-.37V11h1V7h-3v4h-1v-1l-1-1.7V5H9v3.3L8 10v1h1v4zm2-8h1v1h-1V7zm1 3h1v1h-1v-1z',
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z'
  ],
  'skill': [
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'
  ],
  'attribute': [
    'M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zM12 22H5c-1.52 0-2.76-1.24-2.76-2.76 0-1.52 1.24-2.76 2.76-2.76h7v5.52z'
  ],
  'initiative': [
    'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z'
  ],
  'health': [
    'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
  ],
  'humanity': [
    'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-2.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z'
  ]
};